// @flow

import { observer } from "mobx-react";
import React from "react";

import "./EmailShareMedia.scss";

type Props = {
    title: string,
    url: string
};

const subject = `Check out this video on Timelinely`;
const body = `Watch this video on Timelinely:\n\n$TITLE\n\n\n$URL`;

@observer
export default class EmailShareMedia extends React.Component<Props> {
    get subject(): string {
        return encodeURIComponent(subject);
    }

    get body(): string {
        const title = this.props.title.replace("-- Timelinely", "");
        return encodeURIComponent(
            body.replace("$URL", this.props.url).replace("$TITLE", title)
        );
    }

    render() {
        const mailto = `mailto:?subject=${this.subject}&body=${this.body}`;

        return (
            <a
                href={mailto}
                target="_blank"
                className="EmailShareMedia"
                title="Share on Email"
            >
                <i className="fa fa-envelope" />
            </a>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/ShareMedia/EmailShareMedia/EmailShareMedia.js